"use strict";

var _regeneratorRuntime = require("/opt/buildhome/repo/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClubManager = void 0;

var qs_1 = __importDefault(require("qs"));

var Endpoints_1 = require("../Endpoints");

var event_1 = require("../models/event");

var api_1 = require("../util/api");

var base_1 = require("./base");

var ClubManager = /*#__PURE__*/function (_base_1$BaseManager) {
  _inherits(ClubManager, _base_1$BaseManager);

  var _super = _createSuper(ClubManager);

  function ClubManager() {
    _classCallCheck(this, ClubManager);

    return _super.apply(this, arguments);
  }

  _createClass(ClubManager, [{
    key: "getEvents",
    value:
    /**
     * Fetches all of the club events.
     * @param options The options for fetching the events.
     * @returns All of the club events with respect to the given options.
     */
    function getEvents(options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var params, path, response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                params = qs_1.default.stringify(options);
                path = "".concat(Endpoints_1.Endpoints.clubEvents, "?").concat(params);
                _context.next = 4;
                return this.rest.performRequest(path).catch(api_1.emptyCollectionHandler);

              case 4:
                response = _context.sent;
                return _context.abrupt("return", response.events.map(event_1.transformClubEvent));

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }]);

  return ClubManager;
}(base_1.BaseManager);

exports.ClubManager = ClubManager;